// extracted by mini-css-extract-plugin
module.exports = {"empty-sections-block":"empty-sections-block___3Pjnf","empty-sections-line":"empty-sections-line___YHi7K"};